var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapDarkanDala',{attrs:{"fitBoundID":_vm.fitBoundID,"field_id":_vm.field_id,"element_id":_vm.element_id,"company_id":_vm.company_id,"mode":_vm.mode}})
}
var staticRenderFns = []

export { render, staticRenderFns }